import React, { useEffect, useMemo } from 'react'

import { IKanban, IKanbanTask, IKanbanColumn } from '../kanban'
import { useLazyGetCarKanbanBoardCardsQuery, useLazyGetCarKanbanBoardQuery } from '../../../services'

// ----------------------------------------------------------------------
function mapCarStatuses(carStatuses: { CarStatus: string; CarStatusID: number; BoardListPosition: number }[], kanbanCards: any[] = []): IKanban {
  const result: IKanban = {
    tasks: {},
    columns: {},
    ordered: [],
  }

  // 1) Build columns in BoardListPosition order
  const sortedStatuses = [...carStatuses].sort((a, b) => a.BoardListPosition - b.BoardListPosition)

  const statusIdToColumnId: Record<number, string> = {}

  sortedStatuses.forEach((status, index) => {
    const columnId = `${index + 1}-column-${crypto.randomUUID()}`

    result.columns[columnId] = {
      id: columnId,
      name: status.CarStatus,
      taskIds: [],
    }

    statusIdToColumnId[status.CarStatusID] = columnId
    result.ordered.push(columnId)
  })

  // 2) Group cards by CarStatusID and sort within each column by BoardCardPosition (nulls last)
  const cardsByStatus: Record<number, any[]> = {}
  for (const card of kanbanCards) {
    ;(cardsByStatus[card.CarStatusID] ||= []).push(card)
  }

  for (const statusIdStr of Object.keys(cardsByStatus)) {
    const statusId = Number(statusIdStr)
    const list = cardsByStatus[statusId]

    list.sort((a, b) => {
      const A = a.BoardCardPosition
      const B = b.BoardCardPosition
      if (A == null && B == null) return 0
      if (A == null) return 1 // nulls last
      if (B == null) return -1 // nulls last
      return A - B
    })

    const columnId = statusIdToColumnId[statusId]
    if (!columnId) {
      // No matching column for this status; skip or create a fallback column if desired
      continue
    }

    // 3) Create tasks and push IDs to the right column
    const column = result.columns[columnId]
    for (const card of list) {
      const taskId = `task-${card.CarID}` // stable & predictable
      result.tasks[taskId] = {
        id: taskId,
        name: card.Vehicle,
        description: `Stock #${card.StockNumber}`,
        comments: [],
        assignee: [],
        attachments: [],
        due: [null, null],
        status: '',
        priority: '',
        labels: [],
        reporter: {
          id: '1',
          name: 'System',
          avatarUrl: '/assets/images/avatars/avatar_1.jpg',
        },
      }
      column.taskIds.push(taskId)
    }
  }

  return result
}

export function useGetBoard() {
  const [getCarKanbanBoard] = useLazyGetCarKanbanBoardQuery()
  const [getCarKanbanBoardCards] = useLazyGetCarKanbanBoardCardsQuery()
  const [response, setResponse] = React.useState<any>({ data: null, error: null, isLoading: false })
  const [kanbanCards, setKanbanCards] = React.useState<any>([])
  const fetchBoard = async (branch_id?: any) => {
    try {
      if (branch_id) {
        setKanbanCards((await getCarKanbanBoardCards({ branch_id })).data || [])
      }
      setResponse(await getCarKanbanBoard({}))
    } catch (error) {
      console.error('Failed to fetch board:', error)
    }
  }
  useEffect(() => {
    fetchBoard()
  }, [])
  const data: any = mapCarStatuses(response.data || [], kanbanCards || [])
  console.log('mapped data', data)
  return {
    refetchBoard: fetchBoard,
    board: data,
    boardLoading: false,
    boardError: false,
    boardValidating: false,
    boardEmpty: false,
  }
}

// ----------------------------------------------------------------------

export async function createColumn(columnData: IKanbanColumn) {
  /**
   * Work on server
   */
  // const data = { columnData };
  // await axios.post(endpoints.kanban, data, { params: { endpoint: 'create-column' } });
  /**
   * Work in local
   */
  // mutate(
  //   URL,
  //   (currentData: any) => {
  //     const board = currentData.board as IKanban
  //     const columns = {
  //       ...board.columns,
  //       // add new column in board.columns
  //       [columnData.id]: columnData,
  //     }
  //     // add new column in board.ordered
  //     const ordered = [...board.ordered, columnData.id]
  //     return {
  //       ...currentData,
  //       board: {
  //         ...board,
  //         columns,
  //         ordered,
  //       },
  //     }
  //   },
  //   false,
  // )
}

// ----------------------------------------------------------------------

export async function updateColumn(columnId: string, columnName: string) {
  /**
   * Work on server
   */
  // const data = { columnId, columnName };
  // await axios.post(endpoints.kanban, data, { params: { endpoint: 'update-column' } });
  /**
   * Work in local
   */
  // mutate(
  //   URL,
  //   (currentData: any) => {
  //     const board = currentData.board as IKanban
  //     // current column
  //     const column = board.columns[columnId]
  //     const columns = {
  //       ...board.columns,
  //       // update column in board.columns
  //       [column.id]: {
  //         ...column,
  //         name: columnName,
  //       },
  //     }
  //     return {
  //       ...currentData,
  //       board: {
  //         ...board,
  //         columns,
  //       },
  //     }
  //   },
  //   false,
  // )
}

// ----------------------------------------------------------------------

export async function moveColumn(newOrdered: string[]) {
  /**
   * Work in local
   */
  // mutate(
  //   URL,
  //   (currentData: any) => {
  //     const board = currentData.board as IKanban
  //     // update ordered in board.ordered
  //     const ordered = newOrdered
  //     return {
  //       ...currentData,
  //       board: {
  //         ...board,
  //         ordered,
  //       },
  //     }
  //   },
  //   false,
  // )
  /**
   * Work on server
   */
  // const data = { newOrdered };
  // await axios.post(endpoints.kanban, data, { params: { endpoint: 'move-column' } });
}

// ----------------------------------------------------------------------

export async function clearColumn(columnId: string) {
  /**
   * Work on server
   */
  // const data = { columnId };
  // await axios.post(endpoints.kanban, data, { params: { endpoint: 'clear-column' } });
  /**
   * Work in local
   */
  // mutate(
  //   URL,
  //   (currentData: any) => {
  //     const board = currentData.board as IKanban
  //     const { tasks } = board
  //     // current column
  //     const column = board.columns[columnId]
  //     // delete tasks in board.tasks
  //     column.taskIds.forEach((key: string) => {
  //       delete tasks[key]
  //     })
  //     const columns = {
  //       ...board.columns,
  //       [column.id]: {
  //         ...column,
  //         // delete task in column
  //         taskIds: [],
  //       },
  //     }
  //     return {
  //       ...currentData,
  //       board: {
  //         ...board,
  //         columns,
  //         tasks,
  //       },
  //     }
  //   },
  //   false,
  // )
}

// ----------------------------------------------------------------------

export async function deleteColumn(columnId: string) {
  /**
   * Work on server
   */
  // const data = { columnId };
  // await axios.post(endpoints.kanban, data, { params: { endpoint: 'delete-column' } });
  /**
   * Work in local
   */
  // mutate(
  //   URL,
  //   (currentData: any) => {
  //     const board = currentData.board as IKanban
  //     const { columns, tasks } = board
  //     // current column
  //     const column = columns[columnId]
  //     // delete column in board.columns
  //     delete columns[columnId]
  //     // delete tasks in board.tasks
  //     column.taskIds.forEach((key: string) => {
  //       delete tasks[key]
  //     })
  //     // delete column in board.ordered
  //     const ordered = board.ordered.filter((id: string) => id !== columnId)
  //     return {
  //       ...currentData,
  //       board: {
  //         ...board,
  //         columns,
  //         tasks,
  //         ordered,
  //       },
  //     }
  //   },
  //   false,
  // )
}

// ----------------------------------------------------------------------

export async function createTask(columnId: string, taskData: IKanbanTask) {
  /**
   * Work on server
   */
  // const data = { columnId, taskData };
  // await axios.post(endpoints.kanban, data, { params: { endpoint: 'create-task' } });
  /**
   * Work in local
   */
  // mutate(
  //   URL,
  //   (currentData: any) => {
  //     const board = currentData.board as IKanban
  //     // current column
  //     const column = board.columns[columnId]
  //     const columns = {
  //       ...board.columns,
  //       [columnId]: {
  //         ...column,
  //         // add task in column
  //         taskIds: [...column.taskIds, taskData.id],
  //       },
  //     }
  //     // add task in board.tasks
  //     const tasks = {
  //       ...board.tasks,
  //       [taskData.id]: taskData,
  //     }
  //     return {
  //       ...currentData,
  //       board: {
  //         ...board,
  //         columns,
  //         tasks,
  //       },
  //     }
  //   },
  //   false,
  // )
}

// ----------------------------------------------------------------------

export async function updateTask(taskData: IKanbanTask) {
  /**
   * Work on server
   */
  // const data = { taskData };
  // await axios.post(endpoints.kanban, data, { params: { endpoint: 'update-task' } });
  /**
   * Work in local
   */
  // mutate(
  //   URL,
  //   (currentData: any) => {
  //     const board = currentData.board as IKanban
  //     const tasks = {
  //       ...board.tasks,
  //       // add task in board.tasks
  //       [taskData.id]: taskData,
  //     }
  //     return {
  //       ...currentData,
  //       board: {
  //         ...board,
  //         tasks,
  //       },
  //     }
  //   },
  //   false,
  // )
}

// ----------------------------------------------------------------------

export async function moveTask(updateColumns: Record<string, IKanbanColumn>) {
  /**
   * Work in local
   */
  // mutate(
  //   URL,
  //   (currentData) => {
  //     const board = currentData.board as IKanban
  //     // update board.columns
  //     const columns = updateColumns
  //     return {
  //       ...currentData,
  //       board: {
  //         ...board,
  //         columns,
  //       },
  //     }
  //   },
  //   false,
  // )
  /**
   * Work on server
   */
  // const data = { updateColumns };
  // await axios.post(endpoints.kanban, data, { params: { endpoint: 'move-task' } });
}

// ----------------------------------------------------------------------

export async function deleteTask(columnId: string, taskId: string) {
  /**
   * Work on server
   */
  // const data = { columnId, taskId };
  // await axios.post(endpoints.kanban, data, { params: { endpoint: 'delete-task' } });
  /**
   * Work in local
   */
  // mutate(
  //   URL,
  //   (currentData: any) => {
  //     const board = currentData.board as IKanban
  //     const { tasks } = board
  //     // current column
  //     const column = board.columns[columnId]
  //     const columns = {
  //       ...board.columns,
  //       [column.id]: {
  //         ...column,
  //         // delete tasks in column
  //         taskIds: column.taskIds.filter((id: string) => id !== taskId),
  //       },
  //     }
  //     // delete tasks in board.tasks
  //     delete tasks[taskId]
  //     return {
  //       ...currentData,
  //       board: {
  //         ...board,
  //         columns,
  //         tasks,
  //       },
  //     }
  //   },
  //   false,
  // )
}
